import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { userRole } from '../../data/roleData';
import api from '../../utils/axios';
import { ProfileContext } from './contexts';

function useAuth() {
  const profileContext = useContext(ProfileContext);
  const navigate = useNavigate();

  const checkAuth = (path = '/') => {
    if (!profileContext.isLogged) {
      if (!profileContext.fetchingUser) {
        if (!api.accessToken || !api.refreshToken) {
          if (path !== '/login') {
            profileContext.logout();
          }
          return false;
        }

        const sessionStoredUser = JSON.parse(
          sessionStorage.getItem('cec-user')
        );
        const localStoredUser = JSON.parse(localStorage.getItem('cec-user'));

        if (sessionStoredUser !== undefined && sessionStoredUser !== null) {
          profileContext.loginFromStorage(sessionStoredUser);
          return false;
        } else if (localStoredUser !== undefined && localStoredUser !== null) {
          profileContext.loginFromStorage(localStoredUser);
          return false;
        } else {
          if (path !== '/login') navigate('/login');

          return false;
        }
      }
    } else {
      if (!profileContext.fetchingUser) {
        if (
          !profileContext.isAccountValidate &&
          profileContext?.user?.otpActivated
        ) {
          if (path !== '/otp') {
            navigate('/otp');
            return false;
          }
        } else {
          if (path === '/otp') {
            navigate('/');
            return false;
          }
        }
      }
    }

    return true;
  };

  const validateRoleRoute = (role) => {
    if (profileContext.role === userRole.UNDEFINED) return false;
    if (profileContext.role !== role) navigate('/');
    return true;
  };

  return { checkAuth, validateRoleRoute };
}

export default useAuth;
